import { createRouter, createWebHistory } from 'vue-router';

const routes = [
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} 
		else {
			return { top: 0 }
		}
	},
})

export default router;
